import * as React from 'react';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../../context/DataContext';
import { getImageFileName, dataURItoBlob } from '../../utils';

const ClientSignPage = () => {
  const navigate = useNavigate();
  const sigPad = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const { state, uploadInsurePic } = React.useContext(Context);
  const {
    customerInfo: { birthday, orderId },
  } = state;

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        要保人簽名
      </Typography>
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            borderWidth: 1,
            borderRadius: 2,
            borderColor: 'rgba(0,0,0,0.23)',
            borderStyle: 'solid',
            mb: 2,
          }}
        >
          <SignatureCanvas
            ref={sigPad}
            canvasProps={{
              style: { width: '100%', height: 168, display: 'block' },
            }}
          />
        </Box>
        {errorMsg ? (
          <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Button
            color='secondary'
            variant='contained'
            sx={{ width: 128 }}
            onClick={() => {
              // clear signature
              sigPad.current.clear();
            }}
          >
            重簽
          </Button>
          <LoadingButton
            variant='contained'
            sx={{ width: 128 }}
            loading={loading}
            onClick={() => {
              if (errorMsg) setErrorMsg('');

              if (sigPad.current.isEmpty()) {
                setErrorMsg('請簽名');
              } else {
                // save signature
                const picName = getImageFileName() + '.png';
                setLoading(true);
                uploadInsurePic(
                  {
                    orderId,
                    picType: 'sign',
                    picFile: new File(
                      [
                        dataURItoBlob(
                          sigPad.current.getCanvas().toDataURL('image/png')
                        ),
                      ],
                      picName
                    ),
                    picName,
                    picUrl: '',
                  },
                  (data) => {
                    setLoading(false);
                    const { responseCode, responseMsg } = data;

                    if (responseCode === '000') {
                      if (
                        DateTime.now()
                          .diff(DateTime.fromISO(birthday), 'years')
                          .as('years') >= 18
                      ) {
                        navigate('/burglary-insur/store-sign');
                      } else {
                        navigate('/burglary-insur/agent-sign');
                      }
                    } else {
                      setErrorMsg(responseMsg);
                    }
                  }
                );
              }
            }}
          >
            下一步
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ClientSignPage;
